import Layout from "../../components/layout";
import {
  ArrowForward,
  NftImgLeft,
  NftImgRight,
  ArrowForwardOrange,
} from "../../shared/icons";
import { useNavigate } from "react-router-dom";
import {
  HomePageSection,
  MobileBanner,
  TechnologySection,
  MiddleSection,
  SubText,
  ImageSection,
  Container,
  Highlight,
  TextSection,
  ProgressBarContainer,
  ProgressBarWrapper,
  ProgressFill,
  Percentage
} from "./style";
import { IconButton } from "../../components/Buttons";
import PortFolioSection from "../../components/shared-components/PortFolioSection";

const Home = () => {
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 1024;
  interface ProgressBarProps {
    progress: number;
  }
  
  const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
    return (
      <ProgressBarContainer>
        <ProgressBarWrapper>
          <ProgressFill width={progress} />
        </ProgressBarWrapper>
        <Percentage>{progress}%</Percentage>
      </ProgressBarContainer>
    );
  };
  return (
    <Layout fullScreen>
      <HomePageSection>
        <ul>
          <li>
            {/* <h6>01</h6> */}
            <h1>
              AI-powered <span>Catalyst</span>
            </h1>
            <p>
              AI-driven productivity and proper governance – 
              <br />
              empowering upskilling and broad-based growth
            </p>
            <IconButton
              onClick={() => navigate("/marketplace")}
              variant="outlinedTheme"
              icon={<ArrowForwardOrange />}
            >
              Start Discovery
            </IconButton>
          </li>
        </ul>
      </HomePageSection>
      {isMobile && <MobileBanner/>}
      <TechnologySection>
        <ul>
          <li>
            <h2>Technology for<br/>tomorrow</h2>
            <h5>Artificial Intelligence beyond the buzz</h5>
            <p className="select_p_element">
              Selected initiatives across w2, w3 and w4.
            </p>
          </li>
          <li>
            <h4>
            VYGA ©  is an AI-driven catalyst for global impact for infrastructure improvement and long-term efficiency.  We leverage cutting-edge AI to advance workforce productivity & expansion while empowering better governance for broad-based growth for all.
            </h4>
          </li>
        </ul>
      </TechnologySection>
      <MiddleSection>
        <div className="nft_img_content">
          <img src={NftImgLeft} alt="nft image" />
        </div>
        <div>
          <div style={{ padding: 0, marginTop : isMobile ? "0" : "50px" }}>
            <h5>Quantitative and qualitative impact</h5>
            <h2>Next-Gen Impact</h2>
            <p>
            Our goal is to be a comprehensive A-to-Z facilitator for infrastructure value-chain stakeholders to share data, insights and skills in a way that drives productivity and ensures good governance for long-term efficiencies and proper management of externalities.  Vyga supports a range of individual users, corporates and institutions through every step of their knowledge and management journey – helping them rapidly discover, evaluate, develop projects from energy infrastructure and transport projects to ocean clean-ups and carbon offset initiatives. 
            </p>
            <p>
            By leveraging AI, Vyga accelerates the creation of customized solutions such as cross-dimensional products (e.g., ETFs spanning W2 and W3) that ensure projects/initiatives are credible, scalable, and impactful to all stakeholders and local communities.
            </p>
          </div>
          <div className="icon_underline_add">
            <div className="link-hover" onClick={() => navigate("/marketplace")}>
              <h4>AI Cross-Chain Search</h4>
              <ArrowForward className="svg-hover"/>
            </div>
            <div>
              <h4>Future-Proof Upskilling</h4>
              <ProgressBar progress={85} />
            </div>
            <div>
              <h4>Integrated Reporting</h4>
              <ProgressBar progress={20} />
            </div>
          </div>
        </div>
      </MiddleSection>
      <Container>
        <TextSection>
          <Highlight>
            <div>
              <h1>+30%</h1>&nbsp;&nbsp;
              <h2>of investors</h2>
            </div>
            <p>
            have difficulty locating infrastructure opportunities 
            <br />
            that meet target guidelines
            </p>
          </Highlight>
          <Highlight>
            <div>
              <h1>$34</h1>&nbsp;&nbsp;
              <h2>trillion</h2>
            </div>
            <p>Infrastructure projects with complex governance by 2026</p>
          </Highlight>
          <SubText>
            <p>
            As global trade evolves, there will be a greater need for advanced tools to support efficient governance, rapid technology dissemination, faster workforce upskilling, and collaborative innovation.<br/>
            To make this challenge even more complex, there will be the need to comply with an increasingly diverse set of national/regional regulations. For example, the pressure for efficient, future-proof solutions intensifies with the Corporate Sustainability Due Diligence Directive (CSDDD) set to take effect in 2027 – which will impact large companies not only based in the EU but also non-EU companies serving the EU market.
            </p>
          </SubText>
        </TextSection>
        <ImageSection>
          <img src={NftImgRight} alt="ESG Illustration" />
          <div className="line-container">
            <a 
            target="_blank" rel="noopener noreferrer" 
            href="https://www.deutschewealth.com/en/our-capabilities/esg/what-is-esg-investing-wealth-management/ESG-survey-2024.html" className="line-text">
              Source: Deutsche Bank Wealth Management
            </a>
          </div>
        </ImageSection>

      </Container>
      <PortFolioSection />
    </Layout>
  );
};

export default Home;
